import axios from "axios"
import { getUrl, getErrorMessage, headers } from "../networkconfig"

const getDemoRequests = async (token: string|null) => {
  const endpoint = `getDemoRequests`
  const url = getUrl(endpoint)

  try {
    const { data } = await axios.get(url, {
      headers: {
        ...headers(),
        'x-auth-token': token,
      }
    })

    if (!data.status) return { error: "Request error" }

    return parseResponse(data)
  } catch (error) {
    return getErrorMessage(error)
  }
}

const parseResponse = (response: any) => {
  return response
}

export default getDemoRequests